import { ActivatedRouteSnapshot, RedirectCommand, ResolveFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { PageSchema } from '@app/schemas/page';
import { PageService } from '@app/services';

export const pageResolver: ResolveFn<PageSchema | RedirectCommand> = (
  route: ActivatedRouteSnapshot,
) => {
  const router = inject(Router);
  const pageService = inject(PageService);
  const redirectToHome = new RedirectCommand(router.parseUrl('/main/home'));

  const pageId = route.paramMap.get('id');

  if (!pageId) {
    return redirectToHome;
  }

  return pageService.config$.pipe(
    map((pages) => {
      const page = pageService.findPageById(
        pages,
        pageId,
      );

      if (!page) {
        return redirectToHome;
      }

      return page;
    }),
  );
};

export const pageAnimationResolver: ResolveFn<string> = (
  route: ActivatedRouteSnapshot,
) => {
  const pageId = route.paramMap.get('id');
  return `page/${ pageId || 'unknown' }`;
};

export const pageScreenNameResolver: ResolveFn<string> = (
  route: ActivatedRouteSnapshot,
) => {
  const pageService = inject(PageService);
  const pageId = route.paramMap.get('id');

  if (!pageId) {
    return 'Unknown Page';
  }

  return pageService.config$.pipe(
    map((pages) => {
      const page = pageService.findPageById(
        pages,
        pageId,
      );

      if (!page) {
        return 'Unknown Page';
      }

      return page.name.translations[page.name.fallback];
    }),
  );
};

export const pageResolvers = {
  page: pageResolver,
  animation: pageAnimationResolver,
  screen: pageScreenNameResolver,
};
